import { render, staticRenderFns } from "./DevNo.vue?vue&type=template&id=487ef9d4&scoped=true&"
import script from "./DevNo.vue?vue&type=script&lang=js&"
export * from "./DevNo.vue?vue&type=script&lang=js&"
import style0 from "./DevNo.vue?vue&type=style&index=0&id=487ef9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ef9d4",
  null
  
)

export default component.exports